import { key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IPlanFeedbackGenericSlotBuilder } from './plan_feedback_generic_slot_builder';
import { IPlanFeedbackTerm } from './plan_feedback_term_builder';
import { IPlanFeedbackSuggestion, planFeedbackTransactionType } from './plan_feedback_transaction_type';

type PlanFeedbackGenericSlotType = 'COURSE' | 'COURSE_GROUP' | 'TERM' | 'PROGRAM_SLOT';
export interface IFeedbackTransaction {
  transactionNK: string;
  slotNk?: string;
  transactionText: string;
  longTransactionText: string;
  transactionType: planFeedbackTransactionType | 'MET' | 'UNMET';
  type: PlanFeedbackGenericSlotType;
  isForcedToAccept: boolean;
  resolution: IPlanFeedbackSuggestion['resolution'];
  comment?: IPlanFeedbackSuggestion['comment'];
  flagToShow?: boolean;
  acceptEnabled: boolean;
  declineEnabled: boolean;
  acceptButtonText: 'Accept' | 'Got it';
  declineButtonText: 'Decline' | '';
}
export interface IFeedbackTermAndGenericSlot {
  id: key;
  name: IPlanFeedbackTerm['term']['name'];
  term_start_dt: moment.Moment;
  term_end_dt: moment.Moment;
  suggestions: IPlanFeedbackGenericSlotBuilder[];
  creditsRange?: string;
}

export interface IFeedbackTermAndSuggestion {
  id: key;
  nk: string;
  term: IPlanFeedbackTerm['term'];
  suggestions: IFeedbackTransaction[];
}

export class PlanFeedbackTransactionBuilder implements IFeedbackTransaction {
  constructor(
    public transactionNK: IFeedbackTransaction['transactionNK'],
    public transactionText: IFeedbackTransaction['transactionText'],
    public longTransactionText: IFeedbackTransaction['longTransactionText'],
    public transactionType: IFeedbackTransaction['transactionType'],
    public type: IFeedbackTransaction['type'],
    public isForcedToAccept: IFeedbackTransaction['isForcedToAccept'],
    public resolution: IFeedbackTransaction['resolution'],
    public acceptEnabled: IFeedbackTransaction['acceptEnabled'],
    public declineEnabled: IFeedbackTransaction['declineEnabled'],
    public acceptButtonText: IFeedbackTransaction['acceptButtonText'],
    public declineButtonText: IFeedbackTransaction['declineButtonText'],
    public slotNk?: IFeedbackTransaction['slotNk'],
    public comment?: IFeedbackTransaction['comment'],
    public flagToShow?: IFeedbackTransaction['flagToShow']
  ) {}

  static build(
    transactionNK: IFeedbackTransaction['transactionNK'],
    transactionText: IFeedbackTransaction['transactionText'],
    longTransactionText: IFeedbackTransaction['longTransactionText'],
    transactionType: IFeedbackTransaction['transactionType'],
    type: IFeedbackTransaction['type'],
    isForcedToAccept: IFeedbackTransaction['isForcedToAccept'],
    resolution: IFeedbackTransaction['resolution'],
    slotNk?: IFeedbackTransaction['slotNk'],
    fromComment?: IPlanFeedbackSuggestion['from_comment'],
    toComment?: IPlanFeedbackSuggestion['comment']
  ): PlanFeedbackTransactionBuilder {
    const flagChanged = fromComment !== toComment;
    const acceptEnabled = true;
    const declineEnabled = !isForcedToAccept && (!flagChanged || transactionType !== 'NONE');
    const acceptButtonText = isForcedToAccept || flagChanged ? 'Got it' : 'Accept';
    const declineButtonText = declineEnabled ? 'Decline' : '';
    const flagToShow = flagChanged && !_4.isEmpty(toComment);
    return new PlanFeedbackTransactionBuilder(
      transactionNK,
      transactionText,
      longTransactionText,
      transactionType,
      type,
      isForcedToAccept,
      resolution,
      acceptEnabled,
      declineEnabled,
      acceptButtonText,
      declineButtonText,
      slotNk,
      toComment,
      flagToShow
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/builders/plan_feedback_transaction_builder.ts